import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    console.log("SceneUpdateController connected")
  }

  submit(event) {
    console.log("SceneUpdateController submit triggered", event.target)
    // 폼 자동 제출
    this.element.requestSubmit()
  }
}
